'use client';

import { useRef } from 'react';
import CloseIcon from '../icons/close-icon';
import useOnClickOutside from '@/hooks/useOnClickOutside';

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = '',
  headerTitleClassName = '',
  titleClassName = '',
  closeClassName = '',
}) => {
  const modalRef = useRef();
  useOnClickOutside([modalRef], onClose);
  if (!isOpen) return null;

  return (
    <>
      {isOpen && (
        <div className='fixed inset-0 z-1000 flex items-center justify-center bg-black/50'>
          <div
            ref={modalRef}
            className={`red-scroll relative max-h-[95vh] py-2 w-full overflow-y-auto rounded-lg bg-white shadow-lg ${maxWidth}`}
          >
            <div
              className={`flex items-center justify-between border-b border-b-[#EDE8E8] p-4 ${headerTitleClassName}`}
            >
              {title && (
                <h2 className={`text-[20px] font-bold ${titleClassName}`}>
                  {title || ''}
                </h2>
              )}
              <button onClick={onClose} className='cursor-pointer'>
                <CloseIcon className={`size-7 ${closeClassName}`} />
              </button>
            </div>
            {children}
          </div>
        </div>
      )}
    </>
  );
};
export default Modal;
